import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import { Calendar as VCalendar } from "v-calendar";

export default /*#__PURE__*/_defineComponent({
  __name: 'JCalendar',
  setup(__props) {


const attributes = ref([
  {
    key: 'today',
    highlight: true,
    dates: new Date(),
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VCalendar), { attributes: attributes.value }, null, 8, ["attributes"]))
}
}

})